import { AttachmentModel } from '@fc-vehicles/service/attachment-model';

export const getUserPhoto = (
  avatar: string | AttachmentModel | null | undefined,
  width = 96,
  height = 96,
): AttachmentModel[] => {
  if (!avatar) return [];
  if (typeof avatar === 'object') return [avatar];
  return [
    {
      scaledImg: avatar,
      scaledImgWidth: width,
      previewImgWidth: width,
      scaledImgHeight: height,
      previewImgHeight: height,
      previewImg: avatar,
    },
  ];
};
